/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { getTokenFromLS, parseJSON } from "../../lib/helpers";
import posthog from 'posthog-js';
import CustomButton from '../../components/CustomButton/CustomButton.component';
// import {encryptCrypto, decryptCrypto} from '../../lib/helpers';

let timeLeft = 5;

const Oauth = ({ isSignedIn, setSignedIn }) => {
  const [authCode, setAuthCode] = useState("");
  const [message, setMessage] = useState("");
  const [verified, setVerified] = useState(false);
  const [invalidCode, setInvalidCode] = useState(false);
  const [inDesignerMode, setInDesignerMode] = useState(false);
  const [secondsToClose, setSecondsToClose] = useState(5);
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const source = urlParams.get('state');
  const [authSuccessfull, setAuthSuccessfull] = useState(false);
  const [siteShortName,setSiteShortName] = useState("");

  const saveAuthTokenInSession = (token) => {
    window.localStorage.setItem('token', token);
  }

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();
  const history = useHistory();

  useEffect(() => {
    if (query.get("code")) {
      setAuthCode(query.get("code"));
      if (getTokenFromLS()) {
        setMessage("Adding Your Site to Pixie. Please Wait");
        return;
      } else {
        setMessage("Verifying Credentials. Please Wait");
        return;
      }
    } else {
      setMessage("Unable to fetch auth code");
      setInvalidCode(true);
    }
  }, []);

  // Replace the existing fetch code with this updated version
  useEffect(() => {
    console.log('Source:', source);
    
    // Validate we have the code and are coming from InDesigner
    if (code && source === 'indesigner') {
      fetch(`${process.env.REACT_APP_API_ENDPOINT}api/webflow-auth/exchange-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code,
          clientId: process.env.REACT_APP_WEBFLOW_CLIENT_ID,
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setMessage("Authorization successful!");
        
        // Continue with the success flow
        if (window.opener) {
          window.opener.postMessage({
            type: 'INDESIGNER_AUTH_COMPLETE',
            success: true
          }, '*');
        }
        
        // Start countdown timer
        const countdownInterval = setInterval(() => {
          timeLeft -= 1;
          console.log('Time left to close outer:', timeLeft);
          setSecondsToClose(timeLeft);

          if (timeLeft <= 0) {
            clearInterval(countdownInterval);
            console.log('Time left to close inner:', timeLeft);

            try {
              if (window.opener && window.opener.postMessage) {
                window.opener.postMessage({
                  type: 'WEBFLOW_AUTH_SUCCESS',
                  code: query.get("code")
                }, '*');

                window.opener.postMessage({
                  type: 'INDESIGNER_AUTH_COMPLETE',
                  success: true
                }, '*');
              }
            } catch (e) {
              console.error('Error sending message to parent:', e);
            }

            window.close();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }, 1000);
        
        // Update UI state
        setInDesignerMode(true);
      })
      .catch(error => {
        console.error('Authorization failed:', error);
        setMessage("Authorization failed. Please try again.");
        
        // Send failure message to parent window
        if (window.opener) {
          window.opener.postMessage({
            type: 'INDESIGNER_AUTH_COMPLETE',
            success: false,
            error: error.message
          }, '*');
        }
        
        // Still show the inDesigner mode UI but with error message
        setInDesignerMode(true);
        
        // Use a shorter countdown for error case
        timeLeft = 3;
        const countdownInterval = setInterval(() => {
          timeLeft -= 1;
          setSecondsToClose(timeLeft);
          
          if (timeLeft <= 0) {
            clearInterval(countdownInterval);
            window.close();
          }
        }, 1000);
      });
    } else {
      if (source !== 'indesigner') {
        console.log('Not in designer mode, continuing with normal flow');
      }
    }
  }, []);

  useEffect(() => {
    if (query.get("error")) {
      setVerified(true);
    }
  }, []);

  useEffect(() => {
    let interval;
    if (invalidCode) {
      interval = setTimeout(() => {
        setVerified(true);
      }, 3000);
    }
    return () => interval ? clearTimeout(interval) : null;
  }, [invalidCode])

  useEffect(() => {
    if (authCode && source !== 'indesigner') {
      sendAuthCodeToVerify();
    }
  }, [authCode]);

  // useEffect(() => {
  //   if (verified) {
  //     history.push("/pixie");
  //   }
  // }, [verified]);

  const fetchSites = async () => {
    await fetch(`${process.env.REACT_APP_API_ENDPOINT}user/verify-auth-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: getTokenFromLS(),
      },
      body: JSON.stringify({
        authCode,
        clientId: process.env.REACT_APP_WEBFLOW_CLIENT_ID,
      }),
    })
      // .then(parseJSON)
      .then(async (data) => {
        if (data?.status === 401) {
          saveAuthTokenInSession("");
          setMessage("User Unauthorized. Please Login Again");
          setInvalidCode(true);
          setSignedIn(false);
          return;
        }

        data = await parseJSON(data);
        if (data.success) {
          posthog.capture('WebflowSiteAdded',{
            $set: {totalSitesAdded: data.totalSites}
          });
          setMessage("Successfully Added Sites");
          setVerified(true);
          setAuthSuccessfull(true);
          setSiteShortName(data.siteInfo.siteShortName);
          return;
        }
        setMessage("Invalid Auth Code. Please try again.");
        setInvalidCode(true);
      })
      .catch((err) => {
        console.log(err);
        setMessage("Invalid Auth Code. Please try again.");
      });
  }

  const fetchSitesWithWebflow = async (token, authCode) => {
    await fetch(`${process.env.REACT_APP_API_ENDPOINT}user/verify-auth-code-webflow`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({
        secret: authCode,
        clientId: process.env.REACT_APP_WEBFLOW_CLIENT_ID,
      }),
    })
      .then(parseJSON)
      .then((data) => {
        if (data.success) {
          posthog.capture('WebflowSiteAdded',{
            $set: {totalSitesAdded: data.totalSites}
        });
        setSiteShortName(data.siteInfo.siteShortName);
        return data;
        }
        setMessage("Invalid Auth Code. Please try again.");
        setInvalidCode(true);
      })
      .catch((err) => {
        console.log(err);
        setMessage("Invalid Auth Code. Please try again.");
      });
  }

  const fetchUserCredentials = async () => {
    await fetch(`${process.env.REACT_APP_API_ENDPOINT}user/verify-user-auth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        authCode,
        clientId: process.env.REACT_APP_WEBFLOW_CLIENT_ID,
      }),
    })
      .then(response => response.json())
      .then(async (data) => {
        console.log(data)
        if (data.success) {
          if(data.newUser){
            window.fbq('track', 'StartTrial', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
            window.rdt('track', 'Custom', {
              customEventName: 'SignUp',
              email: data.email,
              conversionId: "signup_conversion_16798342"
            });
            posthog.capture('SignedUp',{
              $set: {email: data.email},
              email:data.email,
            });
          }else{
            window.rdt('track', 'Custom', {
              customEventName: 'Login',
              email: data.email
            });
            posthog.capture('SignedIn',{
              $set: {email: data.email},
              email:data.email,
            });
          }
          await fetchSitesWithWebflow(data.token, data.userSecretKey);
          saveAuthTokenInSession(data.token)
          setMessage("Successfully Logged In");
          setSignedIn(true);
          setVerified(true);
          setAuthSuccessfull(true);
          return;
        }
        saveAuthTokenInSession("");
        setMessage("Invalid Auth Code. Please try again.");
        setInvalidCode(true);
      })
      .catch((err) => {
        console.log(err);
        setMessage("Invalid Auth Code. Please try again.");
        setInvalidCode(true);
      });
  }

  const sendAuthCodeToVerify = () => {
    if (getTokenFromLS()) {
      fetchSites();
    } else if (!isSignedIn) {
      fetchUserCredentials();
    }
  };

  return (
    <div className="flex-center" style={{
      backgroundColor: "#f6f6f6",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "60vh", // Full viewport height
      marginLeft: "20px"
    }}>
      {inDesignerMode ? (
        <div className="auth-indesigner-container" style={{ 
          textAlign: 'center', 
          maxWidth: '100%',
          minHeight: '70vh',
          margin: '0 auto', 
          padding: '4rem 2rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          // backgroundColor: 'white', /* Deep purple background color */
          color: 'black'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '2rem' 
          }}>{message}</h2>
          
          <p style={{ 
            fontSize: '1.2rem',
            marginBottom: '2.5rem',
            maxWidth: '600px' 
          }}>
            Your account has been successfully authorized. Pixie is connecting to your Webflow site...
          </p>
          
          <p style={{ 
            fontSize: '1.25rem',
            marginBottom: '2rem' 
          }}>
            Window will close in {secondsToClose} seconds
          </p>
          
          <button 
            onClick={() => window.close()} 
            style={{ 
              marginTop: '1rem',
              padding: '0.8rem 2rem',
              fontSize: '1rem',
              backgroundColor: 'black',
              color: 'white',
              border: 'none',
              borderRadius: '50px',
              cursor: 'pointer',
              fontWeight: 'bold',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
            }}
          >
            Close Now
          </button>
        </div>
      ) : (
        <div className="oauth-wrapper">
        <h2 className="text-msg" style={{ marginBottom: "120px"}}>{message}</h2>
        {authSuccessfull == true && (
        <div className="button-row">              
          <CustomButton 
              black={true}      
              style={{width: "auto"}}
              onClick={() => {
            if (siteShortName) {
              const clientId = process.env.REACT_APP_WEBFLOW_CLIENT_ID;
              const designerURL = `https://${siteShortName}.design.webflow.com?app=${clientId}`;
              window.location.href = designerURL;
            }
          }}>
            Move to in-designer
          </CustomButton>
          <CustomButton black={true} style={{width: "auto"}} onClick={()=> (history.push("/pixie"))}>
            Stay on site
          </CustomButton>
        </div>
      )}
      </div>
      )}
    </div>
  );
};

export default Oauth;